<template>
  <div class="bestaetigung">
    <Header/>
    <Hero step="checkout"/>
    <Checkout/>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import Checkout from '@/components/Checkout.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'CheckoutView',
  components: {
    Header,
    Hero,
    Checkout,
    Footer
  },
  data() {
    return {}
  },
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>
